export default [
  'Active',
  'Inactive',
  'Pending',
  'Sold',
  'Withdrawn',
  'Withdrawal Requested',
  'Available Payout'
]
